/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Status_LinkInputs */

const en_legal_status_link = /** @type {(inputs: Legal_Status_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cannabis law in Thailand`)
};

const th_legal_status_link = /** @type {(inputs: Legal_Status_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กฎหมายกัญชาในประเทศไทย`)
};

const ja_legal_status_link = /** @type {(inputs: Legal_Status_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイの大麻関連法`)
};

const fr_legal_status_link = /** @type {(inputs: Legal_Status_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le cannabis et la loi en Thaïlande`)
};

const es_legal_status_link = /** @type {(inputs: Legal_Status_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El cannabis y la ley en Tailandia`)
};

const ru_legal_status_link = /** @type {(inputs: Legal_Status_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закон о конопле в Таиланде`)
};

const zh_legal_status_link = /** @type {(inputs: Legal_Status_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`泰国大麻法律`)
};

const vi_legal_status_link = /** @type {(inputs: Legal_Status_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luật cần sa tại Thái Lan`)
};

/**
* | output |
* | --- |
* | "Cannabis law in Thailand" |
*
* @param {Legal_Status_LinkInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const legal_status_link = /** @type {((inputs?: Legal_Status_LinkInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Status_LinkInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_legal_status_link(inputs)
	if (locale === "ja") return ja_legal_status_link(inputs)
	if (locale === "fr") return fr_legal_status_link(inputs)
	if (locale === "es") return es_legal_status_link(inputs)
	if (locale === "ru") return ru_legal_status_link(inputs)
	if (locale === "zh") return zh_legal_status_link(inputs)
	if (locale === "vi") return vi_legal_status_link(inputs)
	return en_legal_status_link(inputs)
});